module.exports = __webpack_public_path__ + "img/start-in.c023fd33.svg";